// extracted by mini-css-extract-plugin
export default {"root":"Divider_root__2QGqw","big":"Divider_big__7saXy","mid":"Divider_mid__r6LTe","small":"Divider_small__ZMO+y"};